import React from "react";
import {
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";

import {
  CustomSecondaryEditButton,
  CustomSecondaryDownLoadButton,
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../../Global_Component/GlobalButtonComponent";

const MeatProcurementListPage = () => {
  const services = [
    {
      id: 1,
      service: "Concierge Services:",
      status: "Provided by hotel administration",
      manager: "Mohammad Akhlaq",
      contact: "9878989954",
    },
    {
      id: 2,
      service: "Front Desk Services:",
      status: "Provided by hotel administration",
      manager: "Mohammad Akhlaq",
      contact: "9878989954",
    },
    {
      id: 3,
      service: "Room Service:",
      status: "Provided by hotel administration",
      manager: "Mohammad Akhlaq",
      contact: "9878989954",
    },
    {
      id: 4,
      service: "Luxurious Accommodations:",
      status: "Provided by hotel administration",
      manager: "Mohammad Akhlaq",
      contact: "9878989954",
    },
  ];

  return (
    <Box sx={{ padding: "16px" }}>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Meat Procurement List
        </Typography>
        <Box>
          <CustomSecondaryDownLoadButton sx={{ mr: 1 }} label={"Download"} />
          <CustomSecondaryEditButton sx={{ mr: 1 }} label={"Edit"} />
        </Box>
      </Grid>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Service List</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Manager/Provider/POC Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Manager/Provider/POC Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {services.map((service, index) => (
              <TableRow key={service.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{service.service}</TableCell>
                <TableCell>{service.status}</TableCell>
                <TableCell>{service.manager}</TableCell>
                <TableCell>{service.contact}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <CustomSecondaryButton label={"Cancel"} />
        <CustomSuccessButton label={"Approve"} />
      </Grid>
    </Box>
  );
};

export default MeatProcurementListPage;
